import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useShipFromContext } from '../../../contexts/ship-from-context';

import { Checkbox } from 'ui-components/components/checkbox';

import { messages } from '../../messages';
import style from '../../style.module.less';

export const OriginAsReturnAddressCheckbox = () => {
  const { shipFrom, updateShipFrom, returnAddressSameAsShipFrom, setReturnAddressSameAsShipFrom } = useShipFromContext();
  const intl = useIntl();

  const onChange = useCallback(
    (checked) => {
      setReturnAddressSameAsShipFrom(checked);
      const updatedReturnAddress = checked ? shipFrom.originAddress : shipFrom.returnAddress;
      updateShipFrom({
        returnAddress: { ...updatedReturnAddress },
      });
    },
    [shipFrom, updateShipFrom, setReturnAddressSameAsShipFrom],
  );

  return (
    <Checkbox
      checked={returnAddressSameAsShipFrom}
      className={style.checkbox}
      label={intl.formatMessage(messages.sameAsShipFrom)}
      onChange={onChange}
    />
  );
};
